import { IRequirementDefinitionResponse } from "@wingspanhq/payments/dist/interfaces";
import { ISharedFileRequestSettingsResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { insuranceMonitorSettingsApiSpec } from "@wingspanhq/wingspan-api-types";

import { selectorPolicyTypesFromSettings } from "../../Requirements/modules/InsuranceCoverage/selectors/selectorPolicyTypesFromSettings";
import { RequirementDefinitionSettingsItem } from "../types";

import { getRequirementDefinitionTemplateByParams } from "./getRequirementDefinitionTemplateByParams";

export const getRequirementDefinitionTemplate = (
  requirementDefinition: IRequirementDefinitionResponse,
  settingsItem: RequirementDefinitionSettingsItem,
  strict: boolean = false
) => {
  return getRequirementDefinitionTemplateByParams({
    contextType: (settingsItem as ISharedFileRequestSettingsResponse)
      ?.contextType,
    policyType: selectorPolicyTypesFromSettings(
      settingsItem as insuranceMonitorSettingsApiSpec.InsuranceCoverageMonitorSettings
    ),
    strict,
    type: requirementDefinition.requirementType
  });
};
